import { render, staticRenderFns } from "./StationDisconnectsBubble.vue?vue&type=template&id=2b929ed8&"
import script from "./StationDisconnectsBubble.vue?vue&type=script&lang=ts&"
export * from "./StationDisconnectsBubble.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports